var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-list-form" },
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-bottom": "30px" },
          attrs: { size: "small" },
          model: {
            value: _vm.activeSetting,
            callback: function ($$v) {
              _vm.activeSetting = $$v
            },
            expression: "activeSetting",
          },
        },
        [
          _c("el-radio-button", { attrs: { label: 1 } }, [_vm._v("内容")]),
          _vm._v(" "),
          _c("el-radio-button", { attrs: { label: 2 } }, [_vm._v("样式")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 1,
              expression: "activeSetting==1",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "100px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品来源：" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.goodsType,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "goodsType", $$v)
                    },
                    expression: "itemInfo.goodsType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [
                    _vm._v("指定拼团ID"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "2" } }, [
                    _vm._v("所有未完结拼团"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.itemInfo.goodsType == 1,
                      expression: "itemInfo.goodsType==1",
                    },
                  ],
                },
                [
                  _c("el-input", {
                    staticStyle: { "margin-top": "10px" },
                    attrs: { type: "textarea", rows: 4 },
                    on: { blur: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.skuId,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "skuId", $$v)
                      },
                      expression: "itemInfo.skuId",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#999" } }, [
                    _vm._v("商品以,分割，如商品已下架则不展示！"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 2,
              expression: "activeSetting==2",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "130px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "是否分页：" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-value": 1,
                  "active-text": "是",
                  "inactive-text": "否",
                  "inactive-value": 0,
                },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.showPage,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "showPage", $$v)
                  },
                  expression: "itemInfo.showPage",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商品每页数量：" } },
            [
              _c("el-input-number", {
                attrs: { min: 1 },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.pageLimit,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "pageLimit", $$v)
                  },
                  expression: "itemInfo.pageLimit",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "主题色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.pincolor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "pincolor", $$v)
                  },
                  expression: "itemInfo.pincolor",
                },
              }),
              _vm._v(" "),
              _c("div", { staticStyle: { color: "#999" } }, [
                _vm._v("主题色为标签、按钮、拼团价的颜色"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "背景图片：" } }, [
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _vm.userType === 1
                  ? _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.modalPicTap("1")
                          },
                        },
                      },
                      [
                        _vm.itemInfo.bgImg
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", { attrs: { src: _vm.itemInfo.bgImg } }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    )
                  : _c(
                      "el-upload",
                      {
                        staticClass: "avatar-uploader",
                        attrs: {
                          "show-file-list": false,
                          "before-upload": _vm.beforeImageUpload,
                          "http-request": _vm.handleImageUpload,
                          accept: "image/*",
                        },
                      },
                      [
                        _c("div", { staticClass: "upLoadPicBox" }, [
                          _vm.itemInfo.bgImg
                            ? _c("div", { staticClass: "pictrue" }, [
                                _c("img", {
                                  attrs: { src: _vm.itemInfo.bgImg },
                                }),
                              ])
                            : _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                        ]),
                      ]
                    ),
                _vm._v(" "),
                _vm.itemInfo.bgImg
                  ? _c("i", {
                      staticClass: "el-icon-delete",
                      staticStyle: { color: "red", "font-size": "16px" },
                      on: {
                        click: function ($event) {
                          return _vm.removeImg("image")
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.bgColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "bgColor", $$v)
                  },
                  expression: "itemInfo.bgColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "内间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.pinPadding.pt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.pinPadding, "pt", $$v)
                    },
                    expression: "itemInfo.pinPadding.pt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.pinPadding.pb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.pinPadding, "pb", $$v)
                    },
                    expression: "itemInfo.pinPadding.pb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.pinPadding.pl,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.pinPadding, "pl", $$v)
                    },
                    expression: "itemInfo.pinPadding.pl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.pinPadding.pr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.pinPadding, "pr", $$v)
                    },
                    expression: "itemInfo.pinPadding.pr",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "内部间距：" } },
            [
              _c("el-input-number", {
                attrs: { min: 0 },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.midPadding,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "midPadding", $$v)
                  },
                  expression: "itemInfo.midPadding",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }